module.exports = __webpack_public_path__ + "static/media/9 3 '03_59a2b69c-8b17-406a-8121-62272eb04717.a2619ae8.png";